export const plansFilterMappings: Record<string, string> = {
  // Market filter uses singular marketId as expected by the backend.
  // We still support multi-select in the UI by passing an array of IDs,
  // which listPlans will serialize as a comma-separated marketId param.
  Market: 'marketId',
  States: 'state',
  // Insurance: 'insuranceIds', // Insurance filter mapping
  Status: 'statuses', // Insurance grid status filter mapping
  Payor: 'payorNames', // Payor (friendly name) filter mapping
  q: 'q', // Search query mapping
  providerId: 'providerIds', // Provider ID mapping for API
  practiceIds: 'practiceIds', // Practice IDs mapping for API
};
